const model = (data) => ({
    models: [],
    downloads: 0,
    guest: true,
    purchased: false,
    // Downloads need a verified email address that isn't a disposable one. The product page is cached for
    // everyone, so these come from the list request, not the page.
    verified: false,
    disposable: false,
    product: 0,
    url: '/api/models',
    init() {
        this.product = data.product
        this.url = data.url
        this.loadModels(this.product)
    },
    get canDownload() {
        return !this.guest && this.verified && !this.disposable && Boolean(this.downloads || this.purchased)
    },
    loadModels(product) {
        window.api.get(this.url, { action: 'list', id_product: product }).then((response) => {
            const list = response.data

            this.models = list.models
            this.downloads = list.downloads
            this.guest = list.guest
            this.purchased = list.purchased
            // Missing from an older server (during a rollback, say), whose downloads don't need it. Downloading
            // checks it again on the server.
            this.verified = Boolean(list.verified ?? true)
            this.disposable = Boolean(list.disposable)
            this.product = product

            // What the email verification link did, when the page came from the cache. A page rendered for
            // this customer has it from partials/meta.tpl too, but it's only shown once.
            if (list.notice) {
                window.showEmailVerificationToast(list.notice)
            }
        }).catch(() => {
            this.guest = true
        })
    },
    startDownload(modelId) {
        const popup = window.open(`${this.url}?action=download&id=${modelId}`, '_blank')
        if (popup) popup.focus()
        this.loadModels(this.product)
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('model', model)
})
